/*
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2022-11-01 18:26:49
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2023-03-13 17:41:59
 * @FilePath: \sns-user-frontend\src\service\chat.js
 * @Description: UGC
 */
import { get, post } from './http'

const chatPath = 'chat/frontend/'
const CHAT = {
  // 聊天组列表
  getChatGroupList: (params) => {
    return get(`${chatPath}chat-private/list`, params)
  },
  // 删除聊天组
  deleteChatGroup: (params) => {
    params.needAuth = true
    return post(`${chatPath}chat-private/remove`, params)
  },
  // 删除聊天组
  deleteChat: (params) => {
    params.needAuth = true
    return post(`${chatPath}user-msg/remove`, params)
  },
  // 聊天信息
  getChatList: (params) => {
    return get(`${chatPath}chat-private/launch`, params)
  },
  // 获取最新回复
  getNewChatMsg: (params) => {
    return get(`${chatPath}chat-private/fetch`, params)
  },
  //发送信息
  sendMsg: (params) => {
    params.needAuth = true
    return post(`${chatPath}chat-private/post`, params)
  },
  //置顶chat group
  stickChatGroup: (params) => {
    params.needAuth = true
    return post(`${chatPath}chat-private/top/create`, params)
  },
  //取消置顶chat group
  cancelStickChatGroup: (params) => {
    params.needAuth = true
    return post(`${chatPath}chat-private/top/cancel`, params)
  },

  // 获取黑名单
  getChatBlackList: (params) => {
    return get('/chat/frontend/setting/blacklist/page', params)
  },
  // 移出黑名单用户
  removeBlackListUser: (params) => {
    return post('/chat/frontend/setting/blacklist/remove', params)
  },
  // 添加黑名单用户
  addBlackListUser: (params) => {
    return post('/chat/frontend/setting/blacklist/add', params)
  },
  // 修改私信黑名单设置
  modifyChatSetting: (params) => {
    return post('/chat/frontend/setting/update', params)
  },
  // 获取私信黑名单设置
  getChatSetting: (params) => {
    return get('/chat/frontend/setting/get', params)
  },
  createChatAttachments: (params) => {
    return post('/chat/frontend/attachment/create', params)
  }
}


export default CHAT